import { render } from "./IndicatorSearchSuggestions.vue?vue&type=template&id=001f6820"
import script from "./IndicatorSearchSuggestions.vue?vue&type=script&lang=js"
export * from "./IndicatorSearchSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__